'use client';

import { use } from 'react';
import { Table } from '@mantine/core';
import { WORLD_TYPE } from '@/shared/const/world';
import { components } from '@/shared/types/api/TeraApi';
import { useTranslation } from '@/i18n/client';
import classes from './ServerStatusTable.module.css';

export function Online() {
  return <span style={{ color: '#00FF66' }}>Online</span>;
}

export function Offline() {
  return <span style={{ color: '#FF3300' }}>Offline</span>;
}

export function ServerStatusTable({
  data,
}: {
  data: Promise<components['schemas']['ServerListDTO'][] | undefined>;
}) {
  const servers = use(data);
  const { t } = useTranslation('main');

  const rows = servers
    ? servers.map((server) => (
        <Table.Tr key={server.name}>
          <Table.Td>{server.name}</Table.Td>
          <Table.Td>
            {server.type === WORLD_TYPE.PVE
              ? 'PVE'
              : server.type === WORLD_TYPE.PVP
                ? 'PVP'
                : 'DEV'}
          </Table.Td>
          <Table.Td>{server.isOnline ? <Online /> : <Offline />}</Table.Td>
        </Table.Tr>
      ))
    : null;

  return (
    <Table maw={460} className={classes.table}>
      <Table.Thead className={classes.header}>
        <Table.Tr>
          <Table.Th ta='center'>{t('intro.status.server')}</Table.Th>
          <Table.Th ta='center'>{t('intro.status.type')}</Table.Th>
          <Table.Th ta='center'>{t('intro.status.status')}</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody className={classes.body}>{rows}</Table.Tbody>
    </Table>
  );
}

export default ServerStatusTable;
